import {
    Network,
    Alchemy,
    Wallet,
    AssetTransfersCategory,
    Utils,
} from "alchemy-sdk";

// Optional Config object, but defaults to demo api-key and eth-mainnet.
const settings = {
    apiKey: "5x0sL99q_kwHtJPiejnmkw9OtYuZqWUk", // Replace with your Alchemy API Key.
    network: Network.ETH_SEPOLIA, // Replace with your network.
};

const alchemy = new Alchemy(settings);

export const getTransaction = async (walletAddress) => {
    try {
        const transfers = await alchemy.core.getAssetTransfers({
            fromBlock: "0x0",
            toBlock: "latest",
            toAddress: walletAddress,
            category: [
                AssetTransfersCategory.EXTERNAL,
                AssetTransfersCategory.ERC20,
                AssetTransfersCategory.ERC721,
            ],
        });
        console.log(transfers, ">>>");
        return transfers;
    } catch (error) {
        console.log(error);
    }
};

export const getTransactions = async (txHash) => {
    try {
        let response = await alchemy.core.getTransaction(txHash);
        return response;
    } catch (error) {
        console.log(error);
    }
};

export const getBlocks = async () => {
    try {
        const latestBlockNumber = await alchemy.core.getBlockNumber();
        const fetchTx = await alchemy.core.getBlockWithTransactions(
            +latestBlockNumber
        );
        const tx = fetchTx.transactions.slice(0, 10);
        const blocks = [];
        // let transactions = []
        for (let i = 0; i < 10; i++) {
            const block = await alchemy.core.getBlock(latestBlockNumber - i);
            blocks.push(block);
        }
        const result = { blocks, tx };
        return result;
    } catch (error) {
        console.log(error);
    }
};

export const getWalletBalance = async (walletAddress) => {
    try {
        const balance = await alchemy.core.getBalance(walletAddress, "latest");
        console.log(balance)
        return balance;
    } catch (error) {
        console.log(error);
    }
};

export const getBlockInfo = async (blockNumber) => {
    try {
        const block = await alchemy.core.getBlock(+blockNumber);
        return block;
    } catch (error) {
        console.log(error);
    }
};

export const getHashType = async (query) => {
    try {
        const transaction = await alchemy.core.getTransaction(query);
        const block = await alchemy.core.getBlock(query);

        if (transaction) return "transaction";
        if (block) return "block";
    } catch (error) {
        console.log(error);
    }

    return null;
};

export const sendTransaction = async (privateKey, recepientAddress, value) => {
    try {
        let wallet = new Wallet(privateKey);
        const address = await wallet.getAddress();
        const balance = await alchemy.core.getBalance(address);
        console.log(address);
        console.log(parseInt(balance, 16) / 1e18);
        const nonce = await alchemy.core.getTransactionCount(
            wallet.getAddress()
        );
        console.log(nonce);
        const transaction = {
            to: recepientAddress,
            value: Utils.parseEther(value.toString()),
            gasLimit: "21000",
            maxPriorityFeePerGas: Utils.parseUnits("5", "gwei"),
            maxFeePerGas: Utils.parseUnits("20", "gwei"),
            nonce: nonce,
            type: 2,
            chainId: 1111,
        };

        let rawTransaction = await wallet.signTransaction(transaction);
        console.log("Raw tx: ", rawTransaction);
        const tx = await alchemy.transact.sendTransaction(rawTransaction);
        // let tx = await alchemy.core.sendTransaction(rawTransaction);
        console.log(tx);
        console.log(`https://sepolia.etherscan.io/tx/${tx.hash}`);
        return `https://sepolia.etherscan.io/tx/${tx.hash}`;
    } catch (error) {
        console.log(error);
        return error;
    }
};
